// extracted by mini-css-extract-plugin
module.exports = {"FloatingItems":"FloatingItems_FloatingItems__aDIFH","list":"FloatingItems_list__Kpb5m","item":"FloatingItems_item__iJkq6","icon":"FloatingItems_icon__5xyHS"};